import { createContext, useContext, useState, ReactNode, useCallback } from 'react';

interface DocumentsContextType {
  refreshKey: number;
  refreshDocuments: () => void;
}

const defaultContext: DocumentsContextType = {
  refreshKey: 0,
  refreshDocuments: () => {}
};

const DocumentsContext = createContext<DocumentsContextType>(defaultContext);

export function useDocumentsContext() {
  return useContext(DocumentsContext);
}

interface DocumentsProviderProps {
  children: ReactNode;
}

export function DocumentsProvider({ children }: DocumentsProviderProps) {
  const [refreshKey, setRefreshKey] = useState(0);
  
  const refreshDocuments = useCallback(() => {
    // Increment the key to trigger a refresh
    setRefreshKey(prevKey => prevKey + 1);
  }, []);
  
  return (
    <DocumentsContext.Provider value={{ refreshKey, refreshDocuments }}>
      {children}
    </DocumentsContext.Provider>
  );
}